<div align="right">
  <button  mat-raised-button color="accent" (click)="logout()">
    <mat-icon>logout</mat-icon>
  </button>
</div>

<div class="container" style="margin-top: 1%;">
  <div class="row">
    <div class="col-md-2">
    </div>
    <div class="col-md-8 ">
      <div class="card text-center ">
        <h5 class="card-header">Crear encuesta</h5>
        <div class="card-body">
          <h6 class="card-title">Ingrese el nombre de la encuesta</h6>
          <input type="text" class="form-control" id="nombre-encuesta" placeholder="Ingrese el nombre de la encuesta" [(ngModel)]="nombreEncuesta" required>
          <div *ngIf="nombreEncuesta==''&&enviado" class="alert alert-danger"
          role="alert">
            Ingresa un nombre para la encuesta
          </div>
          <h6 class="card-title text-center" style="margin-top: 3%;">Ingrese las instrucciones de la encuesta</h6>
          <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" [(ngModel)]="instrucciones"></textarea>
          <div *ngIf="instrucciones==''&&enviado" class="alert alert-danger"
          role="alert">
            Ingresa instrucciones para la encuesta
          </div>
          <div class="custom-control custom-checkbox custom-control-inline" >
            <input type="checkbox" class="custom-control-input" [checked]="baremoRequired"
            (change)="baremoRequired = !baremoRequired" id="customCheck1">
            <label class="custom-control-label" for="customCheck1">¿Baremo?</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" class="custom-control-input" [checked]="datosRequired"
            (change)="datosRequired = !datosRequired" id="customCheck2">
            <label class="custom-control-label" for="customCheck2">¿Datos generales?</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" class="custom-control-input" [checked]="checklibre"
            (change)="checklibre = !checklibre" id="customCheck3">
            <label class="custom-control-label" for="customCheck3">Libre</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" class="custom-control-input" [checked]="checkprofesores"
            (change)="checkprofesores = !checkprofesores" id="customCheck4">
            <label class="custom-control-label" for="customCheck4">Profesores</label>
          </div>
          <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" class="custom-control-input" [checked]="checkestudiantes"
            (change)="checkestudiantes = !checkestudiantes" id="customCheck5">
            <label class="custom-control-label" for="customCheck5">Estudiantes</label>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2">
    </div>
    <div class="col-md-8">
      <accordion *ngIf="datosRequired">
        <accordion-group heading="Datos generales de la encuesta" style="margin-top: 1%;" [isOpen]="true" >
          <h6 class="card-title text-center" >Seleccione los datos a requerir</h6>
          <div class="row">
            <div class="col-md-6">
              <div class="custom-control custom-checkbox " *ngFor="let campo of campos">
                <input type="checkbox" class="custom-control-input" id="customCheck{{campo.field}}" [checked]="campo.required"
                (change)="campo.required = !campo.required">
                <label class="custom-control-label" for="customCheck{{campo.field}}">¿{{campo.field}}?</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="custom-control custom-checkbox " *ngFor="let campog of camposGenerales" >
                <input type="checkbox" class="custom-control-input" id="customCheck{{campog.field}}" [checked]="campog.required"
                (change)="campog.required = !campog.required">
                <label class="custom-control-label" for="customCheck{{campog.field}}">¿{{campog.field}}?</label>
              </div>
            </div>
          </div>
        </accordion-group>
      </accordion>
      <accordion >
        <accordion-group heading="{{i+1}}. {{pregunta.question}}" style="margin-top: 1%;" [isOpen]="true" *ngFor='let pregunta of preguntas; index as i' >

              <div class="row">
                <div class="col-6 ">
                  <h6 >Seleccione un tipo de pregunta</h6>
                  <div *ngIf="listTipoPregunta">
                    <select class="custom-select" id="gr" [(ngModel)]="pregunta.questionType"
                      (change)="tipoPreguntaSeleccionado($event.target.value)">
                      <option class="d-none d-sm-block d-md-block" selected disabled="true">SELECCIONE UN TIPO</option>
                      <ng-container *ngFor="let tipoPregunta of listTipoPregunta">
                        <option [ngValue]="tipoPregunta.tipo_pregunta" name="selectAgentReport">{{tipoPregunta.nombre}}</option>
                      </ng-container>
                    </select>
                  </div>
                </div>
                <div class="col-6" *ngIf="listTipoBaremo && baremoRequired" >
                  <h6 >Seleccione un tipo de baremo</h6>
                  <div *ngIf="listTipoBaremo && baremoRequired">
                    <select class="custom-select" id="baremoSelect" >
                      <option class="d-none d-sm-block d-md-block" selected disabled="true">SELECCIONE UN TIPO</option>
                      <ng-container *ngFor="let tipoBaremo of listTipoBaremo">
                        <option [ngValue]="tipoBaremo.nombre" name="selectBaremoType">{{tipoBaremo.nombre}}</option>
                      </ng-container>
                    </select>
                  </div>
                </div>
              </div>
              <h6 class="card-title" style="margin-top: 3%;">Ingrese una pregunta</h6>
              <input type="text" [(ngModel)]="pregunta.question" class="form-control" id="nombre-encuesta" placeholder="Ingrese pregunta" >
              <div *ngIf="pregunta.question==''&&enviado" class="alert alert-danger"
                role="alert">
                  Es obligatorio llenar la pregunta*
                </div>
              <div *ngIf="pregunta.questionType==0">
                  <div style="margin-top: 2%;" class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="radio{{i}}_1" name="radios{{i}}" [(ngModel)]="pregunta.answers[0].answerType" [value]="0" class="custom-control-input" >
                    <label class="custom-control-label" for="radio{{i}}_1">Texto</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="radio{{i}}_2" name="radios{{i}}" [(ngModel)]="pregunta.answers[0].answerType" [value]="5" class="custom-control-input">
                    <label class="custom-control-label" for="radio{{i}}_2">Numerico</label>
                  </div>
                </div>
                <div *ngIf="pregunta.questionType==1">
                  <div class="row" >
                    <h6  style="margin-top: 2%; margin-left: 2%;" >Ingrese las posibles respuestas</h6>
                    <h6 *ngIf="baremoRequired" style="margin-top: 2%; margin-left: 28%;" >Baremo</h6>
                    <div class="col-md-10">
                      <ul class="list-group">
                        <li class="list-group-item py-2" style="border-style: none;" *ngFor='let respuesta of pregunta.answers; index as j'>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                              <input type="radio"  aria-label="Radio button for following text input">
                              </div>
                            </div>
                            <input type="text" [(ngModel)]="respuesta.answer" placeholder="Ingrese una respuesta" class="form-control" aria-label="Text input with radio button">
                            <div *ngIf="baremoRequired" class="input-group-append">
                              <input type="number" class="form-control" [(ngModel)]="respuesta.baremoValue" title="Baremo" placeholder="Baremo" min="1" max="1000">
                            </div>
                            <div class="input-group-append">
                              <button class="btn btn-danger" (click)="eliminarRespuesta(pregunta,j)" type="button"><span class="material-icons">delete</span></button>
                            </div>
                          </div>
                        </li>
                        <li class="list-group-item py-2" style="border-style: none;" >
                          <button type="button" class="btn btn-primary btn-sm btn-block" (click)="agregarRespuesta(pregunta)">Agregar Respuesta</button>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
                <div *ngIf="pregunta.questionType==2 || pregunta.questionType==6">
                  <div class="row" >
                    <h6  style="margin-top: 2%; margin-left: 2%;" >Ingrese las posibles respuestas</h6>
                    <h6 *ngIf="baremoRequired" style="margin-top: 2%; margin-left: 28%;" >Baremo</h6>
                    <div class="col-md-10">
                      <ul class="list-group">
                        <li class="list-group-item py-2" style="border-style: none;" *ngFor='let respuesta of pregunta.answers; index as j'>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <input type="checkbox" aria-label="Checkbox for following text input">
                              </div>
                            </div>
                            <input type="text" [(ngModel)]="respuesta.answer" placeholder="Ingrese una respuesta" class="form-control" aria-label="Text input with checkbox">
                            <div *ngIf="baremoRequired" class="input-group-append">
                              <input type="number" class="form-control" [(ngModel)]="respuesta.baremoValue" title="Baremo" placeholder="Baremo" min="1" max="1000">
                            </div>
                            <div class="input-group-append">
                              <button class="btn btn-danger" (click)="eliminarRespuesta(pregunta,j)" type="button"><span class="material-icons">delete</span></button>
                            </div>
                          </div>
                        </li>
                        <li class="list-group-item py-2"  style="border-style: none;">
                          <button type="button" class="btn btn-primary btn-sm btn-block" (click)="agregarRespuesta(pregunta)">Agregar Respuesta</button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div *ngIf="pregunta.questionType==3">
                </div>
                <div *ngIf="pregunta.questionType==4">
                  <div class="row" >
                    <h6  style="margin-top: 2%; margin-left: 2%;" >Ingrese las posibles respuestas</h6>
                    <h6 *ngIf="baremoRequired" style="margin-top: 2%; margin-left: 28%;" >Baremo</h6>
                    <div class="col-md-10">
                      <ul class="list-group">
                        <li class="list-group-item py-2" style="border-style: none;" *ngFor='let respuesta of pregunta.answers; index as j'>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <div class="input-group-text">

                              </div>
                            </div>
                            <input type="text" [(ngModel)]="respuesta.answer" placeholder="Ingrese una respuesta" class="form-control" aria-label="Text input with radio button">
                            <div *ngIf="baremoRequired" class="input-group-append">
                              <input type="number" class="form-control" [(ngModel)]="respuesta.baremoValue" title="Baremo" placeholder="Baremo" min="1" max="1000">
                            </div>
                            <div class="input-group-append">
                              <button class="btn btn-danger" (click)="eliminarRespuesta(pregunta,j)" type="button"><span class="material-icons">delete</span></button>
                            </div>
                          </div>
                        </li>
                        <li class="list-group-item py-2" style="border-style: none;" >
                          <button type="button" class="btn btn-primary btn-sm btn-block" (click)="agregarRespuesta(pregunta)">Agregar Respuesta</button>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
                <div *ngIf="pregunta.questionType==5">
                  <div style="margin-top: 2%;" class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="radioh{{i}}_1" name="radiosh{{i}}" [(ngModel)]="pregunta.answers[0].answerType" [value]="4" class="custom-control-input" checked="checked" >
                    <label class="custom-control-label" for="radioh{{i}}_1">Unico</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="radioh{{i}}_2" name="radiosh{{i}}" [(ngModel)]="pregunta.answers[0].answerType" [value]="3" class="custom-control-input" >
                    <label class="custom-control-label" for="radioh{{i}}_2">Rango</label>
                  </div>
                  <div *ngIf="pregunta.answers[0].answerType==3" class="custom-control custom-control-inline">
                    <input  type="number" [(ngModel)]="pregunta.answers[0].timeqty" class="form-control" style="width: 80px;" name="Cantidad" id="inputCant" placeholder="Cant.">
                  </div>
                </div>
                <div class="row" style="margin-top: 3%;">
                  <div class="col-md-9"></div>
                  <div class="col-md-2">
                    <button class="btn btn-danger mb-2" id="del-question" (click)="eliminarPregunta(i)">Eliminar pregunta</button>
                  </div>

                </div>

        </accordion-group>
      </accordion>

      <div class="card-footer" style="margin-top: 1%;">
        <button type="button" class="btn btn-success btn-sm btn-block" (click)="agregarPregunta()">Agregar Pregunta</button>
     </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <button type="button" (click)="crearEncuesta()" class="btn btn-primary btn-lg btn-block">CREAR ENCUESTA</button>
    </div>
  </div>
</div>
